"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@chakra-ui/icons");
var _react = require("@chakra-ui/react");
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _react2 = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _reactTable = require("react-table");
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TheTable = props => {
  const [records, setRecords] = (0, _react2.useState)(props.records);
  const [selectedRows, setSelectedRows] = (0, _react2.useState)([]); // currently only one selection is supported
  const [searchQuery, setSearchQuery] = (0, _react2.useState)('');
  (0, _react2.useEffect)(() => {
    setRecords(props.records);
  }, [props.records]);
  const handleRowClick = (_event, id) => {
    const selection = [id];
    setSelectedRows(selection);
    props.onSelectionChange(selection);
    props.onContextMenuClose();
  };
  const handleRowDoubleClick = (_event, id) => props.onSelectionDoubleClick();
  const handleRowContextMenu = (event, id) => {
    event.preventDefault();
    const selection = [id];
    setSelectedRows(selection);
    props.onSelectionChange(selection);
    props.onContextMenu(event, id);
    return false;
  };
  const handleDnD = (dragIndex, dropIndex) => {
    // Don't replace items with themselves
    if (dragIndex === dropIndex) {
      return;
    }
    const dropRecord = records[dropIndex];

    // remove dragIndex from records if dropRecord is a dropzone
    if (dropRecord.isDropzone) {
      setRecords((0, _immutabilityHelper.default)(records, {
        $splice: [[dragIndex, 1]]
      }));
      props.onDnD(dragIndex, dropIndex);
    }
  };
  const handleContainerClick = event => {
    if (event.target === event.currentTarget) {
      setSelectedRows([]);
      props.onSelectionChange([]);
      props.onContextMenuClose();
    }
  };
  const handleContainerContextMenu = event => {
    if (event.target === event.currentTarget) {
      event.preventDefault();
      props.onSelectionChange([]);
      props.onContextMenu(event);
    }
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = (0, _reactTable.useTable)({
    data: records,
    columns: props.columns,
    initialState: props.initialState,
    //@ts-ignore
    autoResetFilters: false,
    autoResetSortBy: false
  }, _reactTable.useSortBy);

  // Filter the rows based on the search query

  const filteredRows = rows.filter(row => Object.values(row.original).some(value => {
    if (value !== undefined && value !== null) {
      return value.toString().toLowerCase().includes(searchQuery.toLowerCase());
    }
    return false;
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDnd.DndProvider, {
    backend: _reactDndHtml5Backend.HTML5Backend,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Box, {
      onClick: handleContainerClick,
      onContextMenu: handleContainerContextMenu,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Input, {
        placeholder: "Search",
        value: searchQuery,
        onChange: e => setSearchQuery(e.target.value),
        mb: 4
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Table, {
        ...getTableProps(),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Thead, {
          position: "sticky",
          top: 0,
          bg: (0, _react.useColorModeValue)('white', 'gray.800'),
          children: headerGroups.map(headerGroup => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tr, {
            ...headerGroup.getHeaderGroupProps(),
            children: headerGroup.headers.map(column => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Th, {
              ...column.getHeaderProps(column.getSortByToggleProps()),
              isNumeric: column.isNumeric,
              w: column.width,
              minW: 200,
              children: [column.render('Header'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.chakra.span, {
                pl: "4",
                children: column.isSorted ? column.isSortedDesc ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TriangleDownIcon, {
                  "aria-label": "sorted descending"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TriangleUpIcon, {
                  "aria-label": "sorted ascending"
                }) : null
              })]
            }))
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tbody, {
          ...getTableBodyProps(),
          children: filteredRows.map(row => {
            prepareRow(row);
            const index = row.index;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow.default, {
              index: index,
              row: row,
              onDnD: handleDnD,
              isSelected: selectedRows.includes(index),
              onClick: handleRowClick,
              onDoubleClick: handleRowDoubleClick,
              onContextMenu: handleRowContextMenu,
              ...row.getRowProps()
            });
          })
        })]
      })]
    })
  });
};
var _default = /*#__PURE__*/_react2.default.memo(TheTable);
exports.default = _default;